import { CountInput } from 'components/Wizards/CountInput/CountInput'
import { CountInputProps } from 'components/Wizards/CountInput/Types'
import { useField } from 'formik'

interface Props extends Omit<CountInputProps, 'value' | 'onChange'> {}

export const NumberInput = (props: Props) => {
  const [field, , helpers] = useField(props.name)

  return <CountInput {...props} value={field.value} onChange={helpers.setValue} />
}
